import _ from "lodash";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import UIButton from "UIComponents/UIButton";
import I18nHOC from "UIComponents/I18nHOC";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import classes from "./AddLE.scss";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import DropDown from "../DropDown";
import AssessmentImportModal from "UnitPlans/components/AssessmentImportModal";
import update from "immutability-helper";
import {
  createAssessment,
  importAssessmentV2,
} from "Assessments/modules/AssessmentModule";
import LeSearchModal from "AppComponents/LeSearchModal";
import { colors } from "Constants";
import classNames from "classnames";
import {
  ButtonDisclosure,
  IconButton,
  IconDisclosure,
  SearchInput,
} from "@toddle-edu/ds-web";
import {
  AddCircleOutlined,
  AddOutlined,
  CloseOutlined,
} from "@toddle-edu/ds-icons";
import { getUnitPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import {
  getLELibraryLabelsMemoize,
  getUnitPlanFieldResponseFilter,
  LE_FEED_STYLES,
} from "UnitPlans/modules/Utils";
import { hasIncludeGivenPathInCurrentRoute } from "IBPlanner/modules/IBPlannerModule";
import { getUnitPlanCentralRepoInputAndFilters } from "Courses/modules/utils";
import {
  getSelectedAcademicYearId,
  getSelectedCourseName,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { ASSESSMENT_TYPE_WORKSHEET } from "Worksheet/modules/WorksheetConstants";
import { getDefaultEntityType } from "ToddleLibrary/modules/ToddleLibraryUtils";
import { getGradeBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { ASSESSMENT_TYPE_AI_TUTOR } from "Constants/stringConstants";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";
import CreateAssignmentModal from "Worksheet/components/WorksheetRevamp/CreateAssignmentModal";
import { isMultiLeImportEnabled } from "AppComponents/LeFeed/modules/LeFeedModule";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";
import { getDynamicAssessmentTypeOptions } from "Course/routes/ClassRoom/modules/utils";

const typeNames = {
  ASSESSMENT: {
    label: "common:assessment_label_plural",
    iconColor: colors.salmon60,
  },
  LEARNING_ENGAGEMENT: {
    label: "common:le_label_plural",
    iconColor: colors.violet500,
  },
  SECOND_STAGE_ASSESSMENT: {
    label: "common:stage_2_assessment_plural",
    iconColor: colors.salmon60,
  },
  THIRD_STAGE_ASSESSMENT: {
    label: "common:stage_3_assessment_plural",
    iconColor: colors.orange500,
  },
  WORKSHEET: {
    label: "worksheet:worksheet_other",
    iconColor: colors.blue500,
  },
  AI_TUTOR: {
    label: "common:ai_tutor_other",
    iconColor: colors.purple500,
  },
};

const buttonStyle = {
  container: {
    minWidth: "252px",
  },
  label: {
    fontSize: "1.4rem",
  },
};

const COACHMARK_PARAMS = {
  target: "#COACHMARKS_IMPORT_LE_FROM_COMMUNITY_UNIT_PLAN",
};

const getImportFromUnitData = ({ t }) => {
  const steps = [
    {
      value: "UNIT_SELECTION",
      label: t("classRoom:import_unit"),
      config: {
        heading: t("classRoom:import_unit"),
        actionButtons: [
          {
            label: "common:cancel",
            value: "cancel",
          },
          {
            label: "common:next",
            value: "next",
          },
        ],
      },
    },
    {
      value: "LE_SELECTION",
      label: t("common:select_learning"),
      config: {
        heading: t("classRoom:import_unit"),
        isMultiSelect: false,
        showLEPreview: true,
        actionButtons: [
          {
            label: "common:cancel",
            value: "cancel",
          },
          {
            label: "common:add",
            value: "add",
          },
        ],
      },
    },
  ];
  const createHeader = t("classRoom:import_unit");

  return { steps, createHeader };
};

const LEDropdownButton = ({
  size,
  assessmentTypeGroup,
  assessmentTypeDetail,
  onSearchChange,
  groupType,
  showLoadingInButton,
  styles,
  isLoading,
  showAddIcon,
  t,
  createText,
  isActivated,
  i18n,
  onClose,
  isUnitFlowRevamp,
  testId,
  //className,
  onClick, // used internally for triggerring dropdown component
}) => {
  if (size == "small") {
    const assessmentType = assessmentTypeGroup
      ? assessmentTypeGroup
      : groupType;

    const typeLabel = _.get(
      typeNames,
      [assessmentType, "label"],
      assessmentType
    );

    const titleTextClasses = classNames({
      [classes.titleText]: true,
      [classes.titleTextRevamp]: isUnitFlowRevamp,
      ["heading-5"]: !isUnitFlowRevamp,
      ["heading-6"]: isUnitFlowRevamp,
    });
    const HeaderContainerClasses = isUnitFlowRevamp
      ? classes.headerContainerRevamped
      : classes.headerContainer;
    return (
      <div className={HeaderContainerClasses}>
        <div className={classes.labelContainer}>
          <div className={titleTextClasses}>{t(typeLabel)}</div>
          {isUnitFlowRevamp && (
            <IconButton
              icon={<CloseOutlined />}
              size={"x-small"}
              variant={"plain"}
              onClick={onClose}
              testId={`${testId}-close`}
            />
          )}
        </div>
        <div className={classes.searchWithDropdown}>
          {isUnitFlowRevamp ? (
            <>
              <SearchInput
                placeholder={getLELibraryLabelsMemoize({
                  assessmentType,
                  assessmentTypeDetail,
                  labelType: "searchText",
                  t,
                  lng: _.get(i18n, "language", "en"),
                })}
                onChange={onSearchChange}
                dsVersion="2.0"
                size="medium"
                testId={testId}
              />
              <IconDisclosure
                size={"medium"}
                icon={<AddOutlined />}
                onClick={onClick}
                dsVersion="2.0"
                variant={"neutral"}
                type={"outlined"}
                isActivated={isActivated}
                testId={`${testId}-addNew`}
              />
            </>
          ) : (
            <ButtonDisclosure
              onClick={onClick}
              size={"large"}
              variant="outlined-subtle"
              icon={<AddOutlined />}
              isActivated={isActivated}
              testId={`${testId}-addNew`}
            >
              {t("common:new")}
            </ButtonDisclosure>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={classes.createTextContainerSmall}
        style={{ ...(styles.createTextContainerSmall || {}) }}
        id="COACHMARKS_IMPORT_LE_FROM_COMMUNITY_UNIT_PLAN"
      >
        <div className={classes.addSvg}>
          {showLoadingInButton && isLoading ? (
            <Loading />
          ) : showAddIcon ? (
            <AddCircleOutlined size="xxx-small" variant="link" />
          ) : null}
        </div>
        {!isLoading ? (
          <div className={classes.createTextSmall}>{createText}</div>
        ) : null}
      </div>
    );
  }
};

const AddLE = ({
  t,
  readOnly,
  list,
  label,
  unitPlanId,
  importAssessmentV2,
  createAssessment,
  setLoadingState,
  isLoading,
  showDropMessage,
  isDraggingOver,
  onSearchOnCommunitySuccess,
  onCreateNewLESuccess,
  onImportFromUnitSuccess,
  styles = {},
  showLoadingInButton,
  showAddIcon,
  eventTarget,
  showCoachmark,
  size,
  groupType,
  curriculumType,
  assessmentTypeGroup,
  assessmentTypes,
  assessmentTypeDetail,
  onSearchChange,
  unitPlanSelectionProps,
  organizationId,
  selectedCourseId,
  academicYearId,
  defaultEntityType,
  globalGradeUid,
  i18n,
  onClose,
  isUnitFlowRevamp,
  testId,
  course,
  courseName,
  isMultiSelectLeEnabled,
  curriculumId,
}) => {
  const [showAssessmentSelectModal, setShowAssessmentSelectModal] = useState(
    false
  );
  const [resourceItems, setResourceItems] = useState([]);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [importFromLeLibrary, setImportFromLeLibrary] = useState(false);
  const [importFromToddleLibrary, setImportFromToddleLibrary] = useState(false);
  const [modalType, setModalType] = useState("");
  const [userInfoPortalType, setUserInfoPortalType] = useState("PLANNER");
  const [activeLibraryEntityType, setActiveLibraryEntityType] = useState(
    defaultEntityType
  );
  const [worksheetAssessmentId, setWorksheetAssessmentId] = useState(false);

  const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();

  // Get dynamic options filtered by groupType when feature flag is enabled
  const dynamicCreateOptions = useMemo(() => {
    if (!isAssessmentTypeConfigurationEnabled || _.isNil(curriculumId)) {
      return [];
    }

    const allOptions = getDynamicAssessmentTypeOptions({
      curriculumId,
      gradeId: globalGradeUid,
    });

    // Filter options by matching taskType with the current groupType
    // taskType in options maps to groupType (e.g., "ASSESSMENT", "LEARNING_ENGAGEMENT")
    const filteredOptions = _.filter(allOptions, option =>
      _.isEqual(_.toUpper(_.get(option, "taskType", "")), _.toUpper(groupType))
    );

    return filteredOptions;
  }, [curriculumId, globalGradeUid, groupType]);

  useEffect(() => {
    if (!_.isEmpty(resourceItems)) {
      onImportFromUnitClick();
    }
  }, [resourceItems]);

  const listLength = _.get(list, "length", 0);

  const assessmentType = {
    CREATE: "le",
    CREATE_FMT_ASSESSMENT: "fmt",
    CREATE_PT_ASSESSMENT: "pt",
    CREATE_PRI_ASSESSMENT: "pri",
    CREATE_SMT_ASSESSMENT: "smt",
    ADD_WORKSHEET: ASSESSMENT_TYPE_WORKSHEET,
    AI_TUTOR: ASSESSMENT_TYPE_AI_TUTOR,
  };

  // Helper function to get dynamic option by key
  const getDynamicOptionByKey = key => {
    const taskTypeId = _.replace(key, "DYNAMIC_CREATE_", "");
    return _.find(dynamicCreateOptions, { taskTypeId });
  };

  const onItemClick = async value => {
    setModalType(value);

    // Handle dynamic create options
    if (_.startsWith(value, "DYNAMIC_CREATE_")) {
      const dynamicOption = getDynamicOptionByKey(value);
      if (dynamicOption) {
        const taskTypeValue = _.get(dynamicOption, "taskType", "");
        const taskTypeId = _.get(dynamicOption, "taskTypeId", "");
        const templateId = _.get(dynamicOption, "templateId", "");

        onCreateNewClicked({
          assessmentType: taskTypeValue,
          taskTypeId,
          templateId,
        });
      }
      return;
    }

    switch (value) {
      case "IMPORT_WORKSHEET":
      case "SEARCH_LE_LIBRARY":
        setImportFromLeLibrary(true);
        setShowSearchModal(true);
        break;
      case "ADD_FROM_OTHER_UNIT":
      case "ADD_FROM_TODDLE_LIBRARY":
        setShowAssessmentSelectModal(true);
        setResourceItems([]);
        break;
      case "IMPORT_WORKSHEET_FROM_TODDLE_LIBRARY":
        setImportFromToddleLibrary(true);
        setShowSearchModal(true);
        setActiveLibraryEntityType("worksheet");
        break;
      case "IMPORT_LE_FROM_TODDLE_LIBRARY":
        setImportFromToddleLibrary(true);
        setShowSearchModal(true);
        break;
      default:
        onCreateNewClicked({ assessmentType: assessmentType[value] });
    }
  };

  const onLeSearchModalClose = () => {
    setShowSearchModal(false);
    setImportFromLeLibrary(false);
    setImportFromToddleLibrary(false);
  };

  const onCreateNewClicked = async ({
    assessmentType = "le",
    taskTypeId,
    templateId,
  } = {}) => {
    if (isLoading) return;
    const loadingProperty = "FULLSCREEN_LOADING";
    setLoadingState(true, loadingProperty);

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });

    const unitPlanAcademicYearsIds = _.map(
      _.get(unitPlanDetails, "academicYears", []),
      item => item.id
    );
    const id = await createAssessment({
      assessmentType,
      groupType,
      academicYears: unitPlanAcademicYearsIds,
      taskTypeId,
      templateId,
    });
    setLoadingState(false, loadingProperty);

    if (assessmentType === "worksheet") {
      // * If worksheet is created, open worksheet initializing modal
      setWorksheetAssessmentId(id);
    } else if (id && onCreateNewLESuccess) {
      onCreateNewLESuccess({ id });
    }
  };

  // Import from units
  const onImportFromUnitClick = async () => {
    setLoadingState(true, "FULLSCREEN_LOADING");

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });

    const unitPlanAcademicYearsIds = _.map(
      _.get(unitPlanDetails, "academicYears", []),
      item => item.id
    );

    const importIds = await importAssessmentV2({
      sourceAssessmentIds: _.get(resourceItems, "selectedAssessments", []),
      assessmentTypes,
      academicYears: unitPlanAcademicYearsIds,
      userInfoPortalType,
      createEntityFlowResource: true,
    });

    setLoadingState(false, "FULLSCREEN_LOADING");
    if (importIds) setShowAssessmentSelectModal(false);

    if (onImportFromUnitSuccess) onImportFromUnitSuccess(importIds);
  };

  const updateResourceItems = ({ key, value } = {}) => {
    setResourceItems(
      update(resourceItems, {
        [key]: { $set: value },
      })
    );
  };

  const renderButtonComponent = ({ singleButton = false } = {}) => {
    const createText = singleButton
      ? t("common:create_new_with_label", {
          label,
        })
      : t("common:add_a_with_label", {
          label,
        });

    return (
      <LEDropdownButton
        size={size}
        assessmentTypeGroup={assessmentTypeGroup}
        assessmentTypeDetail={assessmentTypeDetail}
        onSearchChange={onSearchChange}
        groupType={groupType}
        showLoadingInButton={showLoadingInButton}
        styles={styles}
        isLoading={isLoading}
        showAddIcon={showAddIcon}
        t={t}
        createText={createText}
        i18n={i18n}
        onClose={onClose}
        isUnitFlowRevamp={isUnitFlowRevamp}
        testId={testId}
      />
    );
  };

  const containerClasses = classNames(
    { [classes.container]: true },
    { [classes.dropContainer]: isDraggingOver }
  );

  if (readOnly) return;

  const { steps, createHeader } = getImportFromUnitData({ t });

  const createItemMutation = selectedAssessmentId => {
    setResourceItems({
      selectedAssessments: [selectedAssessmentId],
    });
  };

  return (
    <Fragment>
      {listLength || size == "small" ? (
        <DropDown
          size={size}
          curriculumType={curriculumType}
          renderButtonComponent={renderButtonComponent}
          onItemClick={onItemClick}
          listLength={listLength}
          label={label}
          styles={styles}
          groupType={groupType}
          assessmentTypeGroup={assessmentTypeGroup}
          globalGradeUid={globalGradeUid}
          isUnitFlowRevamp={isUnitFlowRevamp}
          testId={testId}
          dynamicCreateOptions={dynamicCreateOptions}
        />
      ) : (
        <div
          className={containerClasses}
          style={{ ...(styles.container || {}) }}
          id="COACHMARKS_IMPORT_LE_FROM_COMMUNITY_UNIT_PLAN"
        >
          {showDropMessage && isDraggingOver && (
            <div className={classes.dropText}>
              {t("unitPlan:drop_respource_msg")}
            </div>
          )}
          <div
            className={classes.wrapper}
            style={{
              opacity: showDropMessage && isDraggingOver ? 0 : 1,
            }}
          >
            <div className={classes.header} style={{ ...styles.header }}>
              {t("common:add_with_label", {
                label: t("community:learning_experience"),
              })}
            </div>

            {showDropMessage && (
              <Fragment>
                <div
                  className={classes.subText}
                  style={{ marginBottom: 0, ...styles.subText }}
                >
                  {t("unitPlan:add_le_dragging")}
                </div>
                <div className={classes.divider}>
                  <span>{t("common:or")}</span>
                </div>
              </Fragment>
            )}

            <div
              className={classes.buttonGroup}
              id={"COACHMARKS_UNIT_FLOW_CREATE_BUTTON"}
            >
              <UIButton
                type="hollow"
                containerStyle={buttonStyle.container}
                color="blue"
                onClick={() => onItemClick("CREATE")}
              >
                {t("common:create_new_with_label", {
                  label: t("community:learning_experience"),
                })}
              </UIButton>
              <UIButton
                type="hollow"
                containerStyle={buttonStyle.container}
                color="blue"
                onClick={() => onItemClick("IMPORT_FROM_UNITS")}
              >
                {t("common:import_from_unit")}
              </UIButton>
            </div>
          </div>
        </div>
      )}
      {showAssessmentSelectModal ? (
        <AssessmentImportModal
          onClose={() => setShowAssessmentSelectModal(false)}
          updateItems={updateResourceItems}
          onClickAdd={onImportFromUnitClick}
          emptySubTitle={"unitPlan:create_unit_for_course"}
          unitPlanSelectionProps={unitPlanSelectionProps}
          modalType={modalType}
          updateUserInfoPortalType={({ portalType }) => {
            setUserInfoPortalType(portalType);
          }}
          groupType={groupType}
          isMultiSelect={isMultiSelectLeEnabled}
          courseName={courseName}
        />
      ) : null}
      {showSearchModal && (
        <LeSearchModal
          onLeSearchModalClose={onLeSearchModalClose}
          portalType={importFromLeLibrary ? "PLANNER" : "COMMUNITY"}
          importFromLeLibrary={importFromLeLibrary}
          importFromToddleLibrary={importFromToddleLibrary}
          unitPlanId={unitPlanId}
          onSuccess={onSearchOnCommunitySuccess}
          eventTarget={eventTarget}
          assessmentTypes={assessmentTypes}
          groupType={groupType}
          {...(importFromToddleLibrary && { activeLibraryEntityType })}
          {...(importFromToddleLibrary && { setActiveLibraryEntityType })}
          customLeFeedStyles={LE_FEED_STYLES}
          createEntityFlowResource={true}
          isMultiSelect={isMultiSelectLeEnabled}
        />
      )}

      {/* Showing worksheet initializing modal */}
      {Boolean(worksheetAssessmentId) && (
        <CreateAssignmentModal
          course={course}
          assessmentId={worksheetAssessmentId}
          onSubmit={() => {
            onCreateNewLESuccess({ id: worksheetAssessmentId });
            setWorksheetAssessmentId(null);
          }}
          onClose={() => setWorksheetAssessmentId(null)}
        />
      )}
    </Fragment>
  );
};

AddLE.defaultProps = {
  setLoadingState: () => {},
  onClose: () => {},
  showDropMessage: false,
  isDraggingOver: false,
  isLoading: false,
  showLoadingInButton: false,
  showAddIcon: true,
  showCoachmark: false,
};

const mapStateToProps = (state, ownProps) => {
  const { curriculumType } = ownProps;

  const userInfo = getUserInfo({ portalType: ownProps.portalType });
  const userId = userInfo.id;
  const unitPlanSelectionProps = {
    parentType: "COURSE",
  };
  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course",
    ""
  );
  const academicYearId = getSelectedAcademicYearId(state);
  const organizationId = _.get(userInfo, "org_id", "");
  if (hasIncludeGivenPathInCurrentRoute({ path: "/adminunitplans" })) {
    const adminUnitPlanFilters = _.get(state, "adminUnitPlans.filters", {});
    unitPlanSelectionProps.parentType = "ORGANIZATION";
    unitPlanSelectionProps.grades = adminUnitPlanFilters.grades;
    unitPlanSelectionProps.academicYears = adminUnitPlanFilters.academicYears;
    unitPlanSelectionProps.parentId = organizationId;
  }

  const gradeId = _.get(state, "teacher.selected_class.selected_grades[0]", "");

  let defaultEntityType, globalGradeUid;
  if (gradeId) {
    const gradeDetails = getGradeBasicDetailsFromCache(gradeId);
    globalGradeUid = _.get(gradeDetails, "globalGrade.uid", null);
    defaultEntityType = getDefaultEntityType({
      curriculumType,
      globalGradeUid,
    });
  }
  const { isUnitFlowRevampEnabled } = getUnitFlowUtils();
  const isUnitFlowRevamp = isUnitFlowRevampEnabled();
  const isMultiSelectLeEnabled = isMultiLeImportEnabled();

  // Get curriculumId (curriculumProgramId) from state
  const curriculumId = getSelectedCurriculumId(state);

  return {
    userId,
    isData: true,
    isLoading: false,
    organizationId,
    selectedCourseId,
    queryVariables: {
      portalType: ownProps.portalType,
      id: userId,
      entityTypes: "ASSESSMENT",
      first: 8,
      seed: 0.52,
      filters: {},
    },
    unitPlanSelectionProps,
    academicYearId,
    defaultEntityType,
    isUnitFlowRevamp,
    globalGradeUid,
    isMultiSelectLeEnabled,
    curriculumId,
    courseName: getSelectedCourseName(state),
  };
};

const mapActionCreators = {
  importAssessmentV2,
  createAssessment,
};

export default compose(
  I18nHOC({ resource: ["community", "common", "unitPlan"] }),
  connect(mapStateToProps, mapActionCreators),
  withLoader
)(AddLE);
